import { FunctionComponent } from 'react';

import styled from 'styled-components';

import { FileModel } from 'models';

import { FileUrlService } from 'features/exam/services/file-url-service';

export const VideoViewer: FunctionComponent<{ file: FileModel; accessToken: null | string }> = ({ file, accessToken }) => {
  const videoUrl = FileUrlService.resolveFileUrl(file, accessToken);

  // Get file extension to determine MIME type
  const getVideoMimeType = (filename: string): string => {
    const extension = filename.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'mp4':
      case 'm4v':
        return 'video/mp4';
      case 'webm':
        return 'video/webm';
      case 'ogv':
      case 'ogg':
        return 'video/ogg';
      case 'mov':
        return 'video/quicktime';
      case 'avi':
        return 'video/x-msvideo';
      case 'mkv':
        return 'video/x-matroska';
      default:
        return 'video/mp4'; // Default fallback
    }
  };

  const mimeType = getVideoMimeType(file.fileName ?? '');

  return (
    <StyledVideoWrapper>
      <video controls autoPlay preload="metadata" playsInline aria-label={`Video: ${file.fileName ?? 'Untitled'}`}>
        <source src={videoUrl} type={mimeType} />
        Your browser does not support the video tag.
      </video>
    </StyledVideoWrapper>
  );
};

const StyledVideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
